import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import RecipientService from '../../../../services/RecipientService';
import AuthService from '../../../../services/AuthService';
import BankService from '../../../../services/BankService';
import Flags from "react-world-flags";

const RecipientCreateModal = ({ show, handleClose, onDataReload }) => {
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [city, setCity] = useState('');
    const [country, setCountry] = useState('Cameroun');
    const [email, setEmail] = useState('');
    const [username, setUsername] = useState('');
    const [bankAccountInfos, setBankAccountInfos] = useState([]);
    const [walletAccountInfos, setWalletAccountInfos] = useState([]);
    const [banks, setBanks] = useState([]);
    const [touchedFields, setTouchedFields] = useState({
        firstName: false,
        lastName: false,
        city: false,
        country: false,
        email: false
    });
    const [touchedBankFields, setTouchedBankFields] = useState([]);
    const [touchedWalletFields, setTouchedWalletFields] = useState([]);
    const walletTypes = ["ORANGE_MONEY", "MTN_MOBILE_MONEY", "WAVE"];
    const countries = [
        { name: "Cameroun", code: "CM" },
        { name: "Bénin", code: "BJ" },
        { name: "Burkina Faso", code: "BF" },
        { name: "Côte d'Ivoire", code: "CI" },
        { name: "Sénégal", code: "SN" }
    ];
    const countryToCodes = {
        "Cameroun": "237",
        "Bénin": "229",
        "Burkina Faso": "226",
        "Côte d'Ivoire": "225",
        "Sénégal": "221",
    };
    const [showValidation, setShowValidation] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        const currentUser = AuthService.getCurrentUser();
        if (currentUser) {
            setUsername(currentUser.username);
        }
    }, []);

    useEffect(() => {
        const fetchBanks = async () => {
            try {
                const banksData = await BankService.getAllBanks();
                const cameroonBanks = banksData.filter(bank => bank.country === "Cameroun");
                setBanks(cameroonBanks);
            } catch (error) {
                console.error('Error fetching banks:', error.message || error);
            }
        };
        fetchBanks();
    }, []);

    useEffect(() => {
        setBankAccountInfos(bankAccountInfos.map(info => ({
            ...info,
            city: city,
            country: 'Cameroun'
        })));
        setWalletAccountInfos(walletAccountInfos.map(info => ({
            ...info,
            city: city,
            country: country,
            phoneNumber: ''
        })));
    }, [city, country]);

    useEffect(() => {
        if (bankAccountInfos.length > touchedBankFields.length) {
            const newTouchedBankFields = [...touchedBankFields];
            for (let i = touchedBankFields.length; i < bankAccountInfos.length; i++) {
                newTouchedBankFields.push({
                    accountName: false,
                    branchName: false,
                    branchNumber: false,
                    accountNumber: false,
                    accountKey: false,
                    city: false,
                    address: false
                });
            }
            setTouchedBankFields(newTouchedBankFields);
        }
    }, [bankAccountInfos.length]);

    useEffect(() => {
        if (walletAccountInfos.length > touchedWalletFields.length) {
            const newTouchedWalletFields = [...touchedWalletFields];
            for (let i = touchedWalletFields.length; i < walletAccountInfos.length; i++) {
                newTouchedWalletFields.push({
                    phoneNumber: false,
                    accountName: false,
                    walletType: false,
                    city: false,
                    address: false
                });
            }
            setTouchedWalletFields(newTouchedWalletFields);
        }
    }, [walletAccountInfos.length]);

    const handleAddBankAccountInfo = () => {
        setBankAccountInfos([...bankAccountInfos, {
            accountName: '',
            branchName: '',
            branchNumber: '',
            accountNumber: '',
            accountKey: '',
            city: city,
            address: '',
            country: 'Cameroun'
        }]);
    };

    const handleAddWalletAccountInfo = () => {
        setWalletAccountInfos([...walletAccountInfos, {
            phoneNumber: '',
            accountName: '',
            walletType: '',
            city: city,
            address: '',
            country: country
        }]);
    };

    const handleBankAccountInfoChange = (index, field, value) => {
        const updatedBankAccountInfos = [...bankAccountInfos];
        if (field === 'country') {
            value = 'Cameroun';
        }
        updatedBankAccountInfos[index][field] = value;
        setBankAccountInfos(updatedBankAccountInfos);
        const updatedTouchedBankFields = [...touchedBankFields];
        if (updatedTouchedBankFields[index]) {
            updatedTouchedBankFields[index] = {
                ...updatedTouchedBankFields[index],
                [field]: true
            };
            setTouchedBankFields(updatedTouchedBankFields);
        }
    };

    const handleWalletAccountInfoChange = (index, field, value) => {
        const updatedWalletAccountInfos = [...walletAccountInfos];
        if (field === 'country') {
            value = country;
        }
        updatedWalletAccountInfos[index][field] = value;
        setWalletAccountInfos(updatedWalletAccountInfos);
        const updatedTouchedWalletFields = [...touchedWalletFields];
        if (updatedTouchedWalletFields[index]) {
            updatedTouchedWalletFields[index] = {
                ...updatedTouchedWalletFields[index],
                [field]: true
            };
            setTouchedWalletFields(updatedTouchedWalletFields);
        }
    };

    const handleFieldChange = (field, value) => {
        switch (field) {
            case 'firstName':
                setFirstName(value);
                break;
            case 'lastName':
                setLastName(value);
                break;
            case 'city':
                setCity(value);
                break;
            case 'country':
                setCountry(value);
                break;
            case 'email':
                setEmail(value);
                break;
            default:
                break;
        }
        setTouchedFields(prev => ({
            ...prev,
            [field]: true
        }));
    };

    const handleRemoveBankAccountInfo = (index) => {
        const updatedBankAccountInfos = [...bankAccountInfos];
        updatedBankAccountInfos.splice(index, 1);
        setBankAccountInfos(updatedBankAccountInfos);
        const updatedTouchedBankFields = [...touchedBankFields];
        updatedTouchedBankFields.splice(index, 1);
        setTouchedBankFields(updatedTouchedBankFields);
    };

    const handleRemoveWalletAccountInfo = (index) => {
        const updatedWalletAccountInfos = [...walletAccountInfos];
        updatedWalletAccountInfos.splice(index, 1);
        setWalletAccountInfos(updatedWalletAccountInfos);
        const updatedTouchedWalletFields = [...touchedWalletFields];
        updatedTouchedWalletFields.splice(index, 1);
        setTouchedWalletFields(updatedTouchedWalletFields);
    };

    const validateField = (field, value) => {
        switch (field) {
            case 'firstName':
            case 'lastName':
            case 'city':
            case 'accountName':
            case 'branchName':
            case 'address':
                return value.trim() !== '';
            case 'email':
                return value === '' || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
            case 'branchNumber':
                return /^\d{5}$/.test(value);
            case 'accountNumber':
                return /^\d{11}$/.test(value);
            case 'accountKey':
                return /^\d{2}$/.test(value);
            case 'phoneNumber':
                return /^\d{1,15}$/.test(value);
            case 'walletType':
                return walletTypes.includes(value);
            case 'country':
                return countries.map(c => c.name).includes(value);
            default:
                return true;
        }
    };

    const validateForm = () => {
        const isFirstNameValid = validateField('firstName', firstName);
        const isLastNameValid = validateField('lastName', lastName);
        const isCityValid = validateField('city', city);
        const isCountryValid = validateField('country', country);
        const isEmailValid = validateField('email', email);

        const areBankAccountInfosValid = bankAccountInfos.every(info =>
            validateField('accountName', info.accountName) &&
            validateField('branchName', info.branchName) &&
            validateField('branchNumber', info.branchNumber) &&
            validateField('accountNumber', info.accountNumber) &&
            validateField('accountKey', info.accountKey) &&
            validateField('city', info.city) &&
            validateField('address', info.address)
        );

        const areWalletAccountInfosValid = walletAccountInfos.every(info =>
            validateField('phoneNumber', info.phoneNumber) &&
            validateField('accountName', info.accountName) &&
            validateField('walletType', info.walletType) &&
            validateField('city', info.city) &&
            validateField('address', info.address)
        );

        return isFirstNameValid && isLastNameValid && isCityValid &&
            isCountryValid && isEmailValid &&
            areBankAccountInfosValid && areWalletAccountInfosValid;
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setShowValidation(true);
        setTouchedFields({
            firstName: true,
            lastName: true,
            city: true,
            country: true,
            email: true
        });
        setTouchedBankFields(bankAccountInfos.map(() => ({
            accountName: true,
            branchName: true,
            branchNumber: true,
            accountNumber: true,
            accountKey: true,
            city: true,
            address: true
        })));
        setTouchedWalletFields(walletAccountInfos.map(() => ({
            phoneNumber: true,
            accountName: true,
            walletType: true,
            city: true,
            address: true
        })));

        if (!validateForm()) {
            toast.error('Veuillez remplir correctement tous les champs requis.');
            return;
        }

        setIsSubmitting(true);
        setErrorMessage('');

        const formattedWalletAccountInfos = walletAccountInfos.map(info => {
            const countryCode = countryToCodes[country] ? `+${countryToCodes[country]}` : '';
            return {
                ...info,
                phoneNumber: countryCode + info.phoneNumber
            };
        });

        const formData = {
            firstName,
            lastName,
            city,
            country,
            email,
            username,
            recipientAccountInfo: {
                bankAccountInfos,
                walletAccountInfos: formattedWalletAccountInfos
            }
        };

        try {
            await RecipientService.createRecipient(formData);
            toast.success('Contact enregistré avec succès!');
            handleClose();
            resetForm();
            onDataReload();
        } catch (error) {
            toast.error('Erreur lors de l\'enregistrement du contact.');
        } finally {
            setIsSubmitting(false);
        }
    };

    const resetForm = () => {
        setFirstName('');
        setLastName('');
        setCity('');
        setCountry('Cameroun');
        setEmail('');
        setBankAccountInfos([]);
        setWalletAccountInfos([]);
        setShowValidation(false);
        setErrorMessage('');
        setTouchedFields({
            firstName: false,
            lastName: false,
            city: false,
            country: false,
            email: false
        });
        setTouchedBankFields([]);
        setTouchedWalletFields([]);
    };

    const isAddBankAccountButtonDisabled = country !== 'Cameroun';

    const shouldValidate = (field) => {
        return showValidation || touchedFields[field];
    };

    const shouldValidateBankField = (index, field) => {
        return showValidation || (touchedBankFields[index] && touchedBankFields[index][field]);
    };

    const shouldValidateWalletField = (index, field) => {
        return showValidation || (touchedWalletFields[index] && touchedWalletFields[index][field]);
    };

    const getValidationClass = (field, value) => {
        if (!shouldValidate(field)) return '';
        return validateField(field, value) ? 'is-valid' : 'is-invalid';
    };

    const getBankValidationClass = (index, field, value) => {
        if (!shouldValidateBankField(index, field)) return '';
        return validateField(field, value) ? 'is-valid' : 'is-invalid';
    };

    const getWalletValidationClass = (index, field, value) => {
        if (!shouldValidateWalletField(index, field)) return '';
        return validateField(field, value) ? 'is-valid' : 'is-invalid';
    };

    return (
        <Modal size="lg" show={show} onHide={() => { handleClose(); resetForm(); }} backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>Ajouter un Destinataire</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit}>
                    {errorMessage && (
                        <div className="alert alert-danger d-flex justify-content-between align-items-center" role="alert">
                            {errorMessage}
                            <Button variant="outline-danger" size="sm" onClick={() => setErrorMessage('')}>
                                Fermer
                            </Button>
                        </div>
                    )}
                    <Form.Group controlId="lastName" className="form-floating mt-3">
                        <Form.Control
                            type="text"
                            value={lastName}
                            onChange={(e) => handleFieldChange('lastName', e.target.value)}
                            className={getValidationClass('lastName', lastName)}
                            autoComplete="off"
                        />
                        <Form.Label>Nom</Form.Label>
                        {shouldValidate('lastName') && !validateField('lastName', lastName) && (
                            <Form.Control.Feedback type="invalid">
                                Veuillez entrer un nom.
                            </Form.Control.Feedback>
                        )}
                    </Form.Group>
                    <Form.Group controlId="firstName" className="form-floating mt-3">
                        <Form.Control
                            type="text"
                            value={firstName}
                            onChange={(e) => handleFieldChange('firstName', e.target.value)}
                            className={getValidationClass('firstName', firstName)}
                            autoComplete="off"
                        />
                        <Form.Label>Prénom</Form.Label>
                        {shouldValidate('firstName') && !validateField('firstName', firstName) && (
                            <Form.Control.Feedback type="invalid">
                                Veuillez entrer un prénom.
                            </Form.Control.Feedback>
                        )}
                    </Form.Group>
                    <Form.Group controlId="email" className="form-floating mt-3">
                        <Form.Control
                            type="email"
                            value={email}
                            onChange={(e) => handleFieldChange('email', e.target.value)}
                            className={getValidationClass('email', email)}
                            autoComplete="off"
                        />
                        <Form.Label>Email (Optionnel)</Form.Label>
                        {shouldValidate('email') && !validateField('email', email) && (
                            <Form.Control.Feedback type="invalid">
                                Veuillez entrer un email valide.
                            </Form.Control.Feedback>
                        )}
                    </Form.Group>
                    <Form.Group controlId="country" className="form-floating mt-3">
                        <Form.Select
                            value={country}
                            onChange={(e) => {
                                handleFieldChange('country', e.target.value);
                                setBankAccountInfos([]);
                                setWalletAccountInfos([]);
                            }}
                            className={getValidationClass('country', country)}
                            autoComplete="off"
                        >
                            <option value="">Sélectionner un pays</option>
                            {countries.map((c, i) => (
                                <option key={i} value={c.name}>
                                    {c.name}
                                </option>
                            ))}
                        </Form.Select>
                        <Form.Label>Pays</Form.Label>
                        {shouldValidate('country') && !validateField('country', country) && (
                            <Form.Control.Feedback type="invalid">
                                Veuillez sélectionner un pays.
                            </Form.Control.Feedback>
                        )}
                    </Form.Group>
                    <Form.Group controlId="city" className="form-floating mt-3">
                        <Form.Control
                            type="text"
                            value={city}
                            onChange={(e) => handleFieldChange('city', e.target.value)}
                            className={getValidationClass('city', city)}
                            autoComplete="off"
                        />
                        <Form.Label>Ville</Form.Label>
                        {shouldValidate('city') && !validateField('city', city) && (
                            <Form.Control.Feedback type="invalid">
                                Veuillez entrer une ville.
                            </Form.Control.Feedback>
                        )}
                    </Form.Group>

                    {/* Compte Bancaire (visible uniquement si le pays est le Cameroun) */}
                    {country === 'Cameroun' && (
                        <>
                            <div className="mt-4 mb-4 d-flex align-items-center">
                                <div className="flex-grow-1 border-bottom"></div>
                                <h5 className="mx-3 mb-0">Informations de Compte Bancaire</h5>
                                <div className="flex-grow-1 border-bottom"></div>
                            </div>
                            {bankAccountInfos.map((info, index) => (
                                <div key={index} className="mt-3 border p-3 rounded">
                                    <Button variant="danger" onClick={() => handleRemoveBankAccountInfo(index)}>
                                        Supprimer
                                    </Button>
                                    <Form.Group controlId={`accountName-${index}`} className="form-floating mt-3">
                                        <Form.Control
                                            type="text"
                                            value={info.accountName}
                                            onChange={(e) => handleBankAccountInfoChange(index, 'accountName', e.target.value)}
                                            className={getBankValidationClass(index, 'accountName', info.accountName)}
                                            autoComplete="off"
                                        />
                                        <Form.Label>Intitulé du compte</Form.Label>
                                        {shouldValidateBankField(index, 'accountName') && !validateField('accountName', info.accountName) && (
                                            <Form.Control.Feedback type="invalid">
                                                Veuillez entrer un intitulé de compte.
                                            </Form.Control.Feedback>
                                        )}
                                    </Form.Group>
                                    <Form.Group controlId={`branchName-${index}`} className="form-floating mt-3">
                                        <Form.Select
                                            value={info.branchName}
                                            onChange={(e) => handleBankAccountInfoChange(index, 'branchName', e.target.value)}
                                            className={getBankValidationClass(index, 'branchName', info.branchName)}
                                            autoComplete="off"
                                        >
                                            <option value="">Sélectionner une banque</option>
                                            {banks.map((bank, i) => (
                                                <option key={i} value={bank.bankName}>
                                                    {bank.bankName}
                                                </option>
                                            ))}
                                        </Form.Select>
                                        <Form.Label>Nom de l'agence</Form.Label>
                                        {shouldValidateBankField(index, 'branchName') && !validateField('branchName', info.branchName) && (
                                            <Form.Control.Feedback type="invalid">
                                                Veuillez entrer un nom d'agence.
                                            </Form.Control.Feedback>
                                        )}
                                    </Form.Group>
                                    <Form.Group controlId={`branchNumber-${index}`} className="form-floating mt-3">
                                        <Form.Control
                                            type="text"
                                            value={info.branchNumber}
                                            onChange={(e) => handleBankAccountInfoChange(index, 'branchNumber', e.target.value)}
                                            pattern="\d{5}"
                                            className={getBankValidationClass(index, 'branchNumber', info.branchNumber)}
                                            autoComplete="off"
                                        />
                                        <Form.Label>Code agence</Form.Label>
                                        {shouldValidateBankField(index, 'branchNumber') && !validateField('branchNumber', info.branchNumber) && (
                                            <Form.Control.Feedback type="invalid">
                                                Veuillez entrer un code d'agence valide (5 chiffres).
                                            </Form.Control.Feedback>
                                        )}
                                    </Form.Group>
                                    <Form.Group controlId={`accountNumber-${index}`} className="form-floating mt-3">
                                        <Form.Control
                                            type="text"
                                            value={info.accountNumber}
                                            onChange={(e) => handleBankAccountInfoChange(index, 'accountNumber', e.target.value)}
                                            pattern="\d{11}"
                                            className={getBankValidationClass(index, 'accountNumber', info.accountNumber)}
                                            autoComplete="off"
                                        />
                                        <Form.Label>Numéro de Compte</Form.Label>
                                        {shouldValidateBankField(index, 'accountNumber') && !validateField('accountNumber', info.accountNumber) && (
                                            <Form.Control.Feedback type="invalid">
                                                Veuillez entrer un numéro de compte (11 chiffres).
                                            </Form.Control.Feedback>
                                        )}
                                    </Form.Group>
                                    <Form.Group controlId={`accountKey-${index}`} className="form-floating mt-3">
                                        <Form.Control
                                            type="text"
                                            value={info.accountKey}
                                            onChange={(e) => handleBankAccountInfoChange(index, 'accountKey', e.target.value)}
                                            pattern="\d{2}"
                                            className={getBankValidationClass(index, 'accountKey', info.accountKey)}
                                            autoComplete="off"
                                        />
                                        <Form.Label>Clé de Compte</Form.Label>
                                        {shouldValidateBankField(index, 'accountKey') && !validateField('accountKey', info.accountKey) && (
                                            <Form.Control.Feedback type="invalid">
                                                Veuillez entrer une clé de compte (2 chiffres).
                                            </Form.Control.Feedback>
                                        )}
                                    </Form.Group>
                                    <Form.Group controlId={`address-${index}`} className="form-floating mt-3">
                                        <Form.Control
                                            type="text"
                                            value={info.address}
                                            onChange={(e) => handleBankAccountInfoChange(index, 'address', e.target.value)}
                                            className={getBankValidationClass(index, 'address', info.address)}
                                            autoComplete="off"
                                        />
                                        <Form.Label>Adresse (Quartier)</Form.Label>
                                        {shouldValidateBankField(index, 'address') && !validateField('address', info.address) && (
                                            <Form.Control.Feedback type="invalid">
                                                Veuillez entrer une adresse.
                                            </Form.Control.Feedback>
                                        )}
                                    </Form.Group>
                                    <Form.Group controlId={`city-${index}`} className="form-floating mt-3">
                                        <Form.Control
                                            type="text"
                                            value={info.city}
                                            disabled
                                            className="form-control"
                                            autoComplete="off"
                                        />
                                        <Form.Label>Ville</Form.Label>
                                    </Form.Group>
                                    <Form.Group controlId={`country-${index}`} className="form-floating mt-3">
                                        <Form.Control
                                            type="text"
                                            value="Cameroun"
                                            disabled
                                            className="form-control"
                                            autoComplete="off"
                                        />
                                        <Form.Label>Pays</Form.Label>
                                    </Form.Group>
                                </div>
                            ))}


                            <div className="mt-3 mb-5 d-flex justify-content-center align-items-center flex-column">
                                <div className="d-flex flex-column align-items-center">
                                    <p style={{
                                        fontStyle: 'italic',
                                        marginBottom: '10px',
                                        color: '#007bff'
                                    }}>
                                        Cliquer sur le bouton ci-dessous pour ajouter un compte bancaire
                                    </p>

                                    <Button
                                        variant="outline-primary"
                                        onClick={handleAddBankAccountInfo}
                                        disabled={isAddBankAccountButtonDisabled || isSubmitting}
                                        style={{
                                            width: '60px',
                                            height: '60px',
                                            borderRadius: '50%',
                                            border: '2px solid #007bff',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            fontSize: '30px',
                                            fontWeight: 'bold',
                                            padding: '0',
                                            backgroundColor: 'transparent'
                                        }}
                                        className="d-flex justify-content-center align-items-center"
                                    >
                                        +
                                    </Button>
                                </div>
                            </div>


                        </>
                    )}

                    {/* Compte Wallet */}
                    <div className="mt-4 mb-4 d-flex align-items-center">
                        <div className="flex-grow-1 border-bottom"></div>
                        <h5 className="mx-3 mb-0">Informations de Compte Wallet</h5>
                        <div className="flex-grow-1 border-bottom"></div>
                    </div>
                    {walletAccountInfos.map((info, index) => (
                        <div key={index} className="mt-3 border p-3 rounded">
                            <Button variant="danger" onClick={() => handleRemoveWalletAccountInfo(index)}>
                                Supprimer
                            </Button>
                            <Form.Group controlId={`walletType-${index}`} className="form-floating mt-3">
                                <Form.Select
                                    value={info.walletType}
                                    onChange={(e) => handleWalletAccountInfoChange(index, 'walletType', e.target.value)}
                                    className={getWalletValidationClass(index, 'walletType', info.walletType)}
                                    autoComplete="off"
                                >
                                    <option value="">Sélectionner un type de wallet</option>
                                    {walletTypes.map((type, i) => (
                                        <option key={i} value={type}>
                                            {type}
                                        </option>
                                    ))}
                                </Form.Select>
                                <Form.Label>Type de Wallet</Form.Label>
                                {shouldValidateWalletField(index, 'walletType') && !validateField('walletType', info.walletType) && (
                                    <Form.Control.Feedback type="invalid">
                                        Veuillez sélectionner un type de wallet.
                                    </Form.Control.Feedback>
                                )}
                            </Form.Group>
                            <Form.Group controlId={`phoneNumber-${index}`} className="form-floating mt-3">
                                <Form.Label>Numéro de téléphone</Form.Label> <br/><br/>
                                <div className="d-flex align-items-center">
                                    <div className="d-flex align-items-center" style={{ marginRight: '10px' }}>
                                        <Flags
                                            code={countries.find(c => c.name === country)?.code || "CM"}
                                            style={{ width: "20px", marginRight: "5px" }}
                                        />
                                        <span>+{countryToCodes[country] || "237"}</span>
                                    </div>
                                    <Form.Control
                                        type="text"
                                        value={info.phoneNumber}
                                        onChange={(e) => handleWalletAccountInfoChange(index, 'phoneNumber', e.target.value)}
                                        className={getWalletValidationClass(index, 'phoneNumber', info.phoneNumber)}
                                        autoComplete="off"
                                        placeholder="Saisissez le numéro"
                                        pattern="\d*"
                                        maxLength={15}
                                        onInput={(e) => {
                                            e.target.value = e.target.value.replace(/[^0-9]/g, '');
                                        }}
                                    />
                                </div>
                                {shouldValidateWalletField(index, 'phoneNumber') && !validateField('phoneNumber', info.phoneNumber) && (
                                    <Form.Control.Feedback type="invalid">
                                        Veuillez entrer un numéro de téléphone valide (uniquement des chiffres, max 15 chiffres).
                                    </Form.Control.Feedback>
                                )}
                            </Form.Group>
                            <Form.Group controlId={`accountName-${index}`} className="form-floating mt-3">
                                <Form.Control
                                    type="text"
                                    value={info.accountName}
                                    onChange={(e) => handleWalletAccountInfoChange(index, 'accountName', e.target.value)}
                                    className={getWalletValidationClass(index, 'accountName', info.accountName)}
                                    autoComplete="off"
                                />
                                <Form.Label>Nom du Compte Wallet</Form.Label>
                                {shouldValidateWalletField(index, 'accountName') && !validateField('accountName', info.accountName) && (
                                    <Form.Control.Feedback type="invalid">
                                        Veuillez entrer un nom de compte.
                                    </Form.Control.Feedback>
                                )}
                            </Form.Group>
                            <Form.Group controlId={`address-${index}`} className="form-floating mt-3">
                                <Form.Control
                                    type="text"
                                    value={info.address}
                                    onChange={(e) => handleWalletAccountInfoChange(index, 'address', e.target.value)}
                                    className={getWalletValidationClass(index, 'address', info.address)}
                                    autoComplete="off"
                                />
                                <Form.Label>Adresse (Quartier)</Form.Label>
                                {shouldValidateWalletField(index, 'address') && !validateField('address', info.address) && (
                                    <Form.Control.Feedback type="invalid">
                                        Veuillez entrer une adresse.
                                    </Form.Control.Feedback>
                                )}
                            </Form.Group>

                            <Form.Group controlId={`country-${index}`} className="form-floating mt-3">
                                <Form.Control
                                    type="text"
                                    value={country}
                                    disabled
                                    className="form-control"
                                    autoComplete="off"
                                />
                                <Form.Label>Pays</Form.Label>
                            </Form.Group>

                            <Form.Group controlId={`city-${index}`} className="form-floating mt-3">
                                <Form.Control
                                    type="text"
                                    value={info.city}
                                    disabled
                                    className="form-control"
                                    autoComplete="off"
                                />
                                <Form.Label>Ville</Form.Label>
                            </Form.Group>

                        </div>
                    ))}


                    <div className="mt-3 mb-5 d-flex justify-content-center align-items-center flex-column">
                        <div className="d-flex flex-column align-items-center">
                            <p style={{
                                fontStyle: 'italic',
                                marginBottom: '10px',
                                color: '#007bff'
                            }}>
                                Cliquer sur le bouton ci-dessous pour ajouter un compte wallet
                            </p>

                            <Button
                                variant="outline-primary"
                                onClick={handleAddWalletAccountInfo}
                                disabled={isSubmitting}
                                style={{
                                    width: '60px',
                                    height: '60px',
                                    borderRadius: '50%',
                                    border: '2px solid #007bff',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    fontSize: '30px',
                                    fontWeight: 'bold',
                                    padding: '0',
                                    backgroundColor: 'transparent'
                                }}
                                className="d-flex justify-content-center align-items-center"
                            >
                                +
                            </Button>
                        </div>
                    </div>


                    <Modal.Footer className="d-flex justify-content-end gap-2" style={{ paddingBottom: '80px' }}>
                        <Button variant="secondary" onClick={() => { handleClose(); resetForm(); }} disabled={isSubmitting}>
                            Annuler
                        </Button>
                        <Button variant="primary" type="submit" disabled={isSubmitting}>
                            {isSubmitting ? 'Chargement...' : 'Sauvegarder'}
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default RecipientCreateModal;
